<template>
  <ApplicationWrapper :routes="routes" :hidePageHeader="hidePageHeader">
    <router-view v-slot="{ Component }">
      <v-snackbar
        v-model="showSnack"
        :timeout="snack?.timeout"
        :color="snack?.color"
        location="top"
      >
        {{ snack?.text }}
        <template v-slot:actions>
          <v-btn variant="text" @click="showSnack = false">Close</v-btn>
        </template>
      </v-snackbar>
      <component :is="Component" ref="component" />
    </router-view>
  </ApplicationWrapper>
</template>

<script setup>
import { ref, computed } from 'vue';
import { ApplicationWrapper, useRootStore } from '@qsrsoft/myq-core';
import routes from './views/routes';
import { useStore } from '@/store';
import { storeToRefs } from 'pinia';

const store = useStore();
const { snack } = storeToRefs(store);
const { locations } = storeToRefs(useRootStore());
const showSnack = computed({
  get: () => !!snack.value,
  set: (v) => (snack.value = v),
});

const component = ref();
const hidePageHeader = computed(() => component?.value?.hidePageHeader);
</script>
